module.exports = __webpack_public_path__ + "static/media/damiloju-profile-image.dfac5146.svg";